import ISourceOfFundsDataStore from '../IsourceOfFunds'
import { API } from 'aws-amplify'

class SourceOfFundsDataStoreAWS extends ISourceOfFundsDataStore {

  handleError(err, functionName) {
    if (err.response) {
      let text = `${err.message} ${JSON.stringify(err.response.data)}`
      if (err.response && err.response.data && err.response.data.message) {
        text = `${err.message} ${err.response.data.message}`
      }
      console.log(`ERROR ${functionName} status: ${err.response.status}`)
      console.log(`ERROR ${functionName} data: ${JSON.stringify(err.response.data)}`)
      console.log(`ERROR ${functionName} headers: ${JSON.stringify(err.response.headers, null, 2)}`)
      let error = new Error(text)
      error.status = err.response.status
      error.statusText = err.response.statusText
      return error
    }
    console.log(`ERROR ${functionName} request: ${err.message}`)
    return err
  }

  getSof = async () => {
    try {
      const response = await API.get('dreamportalsofview', `/portal/admin/sof/object`, {
        response: true,
        headers: {
          Accept: 'application/json',
        },
      })
      return response.data.sof
    }
    catch (error) {
      throw this.handleError(error, 'SOF get (list)')
    }
  }

  putSof = async (sof) => {
    try {
      await API.put('dreamportalsofview', `/portal/admin/sof/object`, {
        body: {
          sof,
        },
        response: true,
        headers: {
          Accept: 'application/json',
        }
      })
    }
    catch (error) {
      throw this.handleError(error, `SOF put (update)`)
    }
  }
 
  postSofUser = async (user) => {
    try {
      const response = await API.post('dreamportalsofview', `/portal/admin/sof-user`, {
        body: {
          user: {...user}
        },
        response: true,
        headers: {
          Accept: 'application/json',
        }
      })
      return response.data.sof
    }
    catch (error) {
      throw this.handleError(error, 'SOF User post (create)')
    }
  }

  putSofUser = async (sofUserId, user) => {
    try {
      await API.put('dreamportalsofview', `/portal/admin/sof-user/object/${sofUserId}`, {
        body: {
          user: { ...user},
        },
        response: true,
        headers: {
          Accept: 'application/json',
        }
      })
    }
    catch (error) {
      throw this.handleError(error, `SOF User put (update)`)
    }
  }
 
  getSofUserList = async (filter, limit, next) => {
    try {
      const response = await API.get('dreamportalsofview', `/portal/admin/sof-user`, {
        response: true,
        headers: {
          Accept: 'application/json',
        },
        queryStringParameters: {
          filter,
          limit,
          next
        }
      })
      return response.data.sofUserList
    }
    catch (error) {
      throw this.handleError(error, 'SOF User get (list)')
    }
  }

  getSofUser = async (sofUserId) => {
    try {
      const response = await API.get('dreamportalsofview', `/portal/admin/sof-user/object/${sofUserId}`, {
        response: true,
        headers: {
          Accept: 'application/json',
        },
      })
      return response.data.sofUser
    }
    catch (error) {
      throw this.handleError(error, `SOF User getSofUser (retrieve)`)
    }
  }

  postAddSofUserToAdmin = async (sofUserId) => {
    try {
      await API.post('dreamportalsofview', `/portal/admin/sof-user/admin/object/${sofUserId}`, {
        response: true,
        headers: {
          Accept: 'application/json',
        }
      })
    }
    catch (error) {
      throw this.handleError(error, 'SOF User post user to admin (make a user an admin)')
    }
  }

  postRemoveSofUserFromAdmin = async (sofUserId) => {
    try {
      await API.del('dreamportalsofview', `/portal/admin/sof-user/admin/object/${sofUserId}`, {
        response: true,
        headers: {
          Accept: 'application/json',
        }
      })
    }
    catch (error) {
      throw this.handleError(error, 'SOF User del user to admin (make a user an admin)')
    }
  }

  putResendPasswordSofUser = async (sofUserId) => {
    try {
      await API.put('dreamportalsofview', `/portal/admin/sof-user/resend-pw/object/${sofUserId}`, {
        response: true,
        headers: {
          Accept: 'application/json',
        }
      })
    }
    catch (error) {
      throw this.handleError(error, 'SOF User put resend password')
    }
  }

  putResetPasswordSofUser = async (sofUserId) => {
    try {
      await API.put('dreamportalsofview', `/portal/admin/sof-user/reset-pw/object/${sofUserId}`, {
        response: true,
        headers: {
          Accept: 'application/json',
        }
      })
    }
    catch (error) {
      throw this.handleError(error, 'SOF User put reset password')
    }
  }

  retrieveSof() {
    return this.getSof()
  }

  storeSof(sof) {
    return this.putSof(sof)
  }

  listSofUsers(filter, limit, next) {
    return this.getSofUserList(filter, limit, next)
  }
  
  retrieveSofUser(sofUserId) {
    return this.getSofUser(sofUserId)
  }
  
  storeSofUser(sofUserId, user) {
    return this.putSofUser(sofUserId, user)
  }

  createSofUser(user) {
    return this.postSofUser(user)
  }

  addSofUserToAdmin(sofUserId) {
    return this.postAddSofUserToAdmin(sofUserId)
  }

  removeSofUserFromAdmin(sofUserId) {
    return this.postRemoveSofUserFromAdmin(sofUserId)
  }

  resendPasswordToSofUser(sofUserId) {
    return this.putResendPasswordSofUser(sofUserId)
  }

  resetPasswordToSofUser(sofUserId) {
    return this.putResetPasswordSofUser(sofUserId)
  }

}

export default SourceOfFundsDataStoreAWS